import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { BX_COMISSION_FILTER_EXPERIMENT } from 'shared/constants/experiments';
import { useExperiment, useFilterChangeCallback } from 'shared/hooks';
import { selectRentCommissionFilter } from 'shared/selectors/advancedFilters';

export const RentCommissionContainer: FC = () => {
  const isRentCommissionFilterEnabled = useExperiment(BX_COMISSION_FILTER_EXPERIMENT);
  const { label, value, options } = useSelector(selectRentCommissionFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (newValue: number | null) => {
      onChange({ action: 'setRentCommission', arguments: [newValue] });
    },
    [onChange],
  );

  if (!isRentCommissionFilterEnabled) {
    return null;
  }

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleChange} />
    </AdvancedFilterRow>
  );
};
